module.exports = __webpack_public_path__ + "img/lg_ring_y_o_0_0@3x.87d09377.png";